import { BulkOverallSubmissionResult } from "../../../types";

export const defaultBulkOverallSubmissionResult: BulkOverallSubmissionResult = {
  message: "",
  result: null,
};
